import { Icon } from '@twilio/flex-ui';
import React from 'react';

import Button from '../../../../../Button';
import { ActionIconStyles } from './styled';

interface ISuggestedActionButtonProps {
  response: string;
  existingActions: string[];
  addSuggestedAction: (action: string) => void;
  deleteSuggestedAction: (response: string) => void;
  updateSuggestedAction: (newValue: string, oldValue: string) => void;
  showErrorMessage: (error: boolean) => void;
  setSelectedInput: (value: string) => void;
  selectedOption: string;
}

interface ISuggestedActionButtonState {
  inputValue?: string;
  existingActions: string[];
  isValid: boolean;
}

class SuggestedActionButton extends React.Component<ISuggestedActionButtonProps, ISuggestedActionButtonState> {
  public inputRef: HTMLInputElement | null = null;
  constructor(props: ISuggestedActionButtonProps) {
    super(props);
    this.state = {
      inputValue: '',
      existingActions: [],
      isValid: true,
    };
  }

  public componentDidMount() {
    this.inputRef && this.inputRef.focus();
    this.initialize();
  }

  public componentDidUpdate(prevProps: ISuggestedActionButtonProps) {
    if (prevProps.response !== this.props.response) {
      this.initialize();
    }
  }

  public componentWillUnmount() {
    this.props.setSelectedInput('');
  }

  public render() {
    const { response, selectedOption, setSelectedInput } = this.props;
    const actionIcon = 'Close';
    const { inputValue, isValid } = this.state;
    const isError = inputValue && !isValid;

    return (
      <Button
        colorOverride={isError ? 'red' : response ? '#029DFF' : '#ddd'}
        size='small'
        secondary
        onKeyDown={this.handleKeyDown}
        onClick={() => {
          setTimeout(() => {
            setSelectedInput(response);
            this.inputRef && this.inputRef.focus();
          }, 0);
        }}>
        {response && response !== selectedOption ? response :
          <input ref={o => this.inputRef = o}
            type='text'
            value={inputValue}
            onChange={(event) => this.handleChange(event)} />
        }
        {response && <ActionIconStyles onClick={() => this.iconClickAction(response)}
        >
          <Icon icon={actionIcon} />
        </ActionIconStyles>}
      </Button>
    );
  }
  public iconClickAction = (response: string) => {
    const { deleteSuggestedAction } = this.props;
    deleteSuggestedAction(response);
  }

  public initialize = () => {
    this.setState({
      existingActions: this.props.existingActions,
      inputValue: this.props.response,
      isValid: true,
    });
    this.props.setSelectedInput('');
  }

  public checkForDuplicate = (value: string) => {
    const { existingActions, showErrorMessage, response } = this.props;
    const hasChanged = value !== response;

    const matchingActions = existingActions.filter(item => item === value);
    let isValid = true;

    if (matchingActions.length > 0 && value && hasChanged) {
      isValid = false;
    }
    this.setState({ isValid });
    showErrorMessage(!isValid);
    return isValid;
  }

  public handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      inputValue: event!.target.value,
    });
    this.checkForDuplicate(event!.target.value);
  }
  public handleKeyDown = (event: React.KeyboardEvent) => {
    const {
      deleteSuggestedAction,
      response,
      showErrorMessage,
    } = this.props;
    const { inputValue } = this.state;

    // if it's the enter key
    if (event.keyCode === 13) {
      if (response) {
        this.handleUpdateSuggestion();
      } else {
        this.handleAddSuggestion();
      }
    }
    // if we're deleting an empty field
    if (event.keyCode === 8 && !inputValue) {
      // deleting a focused existing button
      deleteSuggestedAction(response);
      showErrorMessage(false);
    }
  }
  public handleAddSuggestion = () => {
    const { inputValue } = this.state;
    const { addSuggestedAction } = this.props;
    if (inputValue && this.checkForDuplicate(inputValue)) {
      addSuggestedAction(inputValue);
      this.setState({ inputValue: '' });
    }
  }

  private handleUpdateSuggestion = () => {
    const { inputValue } = this.state;
    const { response, updateSuggestedAction } = this.props;
    if (inputValue && this.checkForDuplicate(inputValue)) {
      updateSuggestedAction(inputValue, response);
      this.setState({ inputValue: '' });
    }
  }
}

export default SuggestedActionButton;
